/**
 * The callback reminder fire-window rule — extracted from the old
 * CallbackReminderHost so it is unit-testable without React, and so it outlived
 * that host when the D-2 overlay manager took over the presentation.
 */

export type ReminderWindow = 'm10' | 'm1';

/**
 * Returns the window that is CURRENTLY due (not yet past) for the given minutes
 * until the slot, or null. A booking < 10 min out never satisfies m10, so it
 * correctly gets only the m1 pop-up.
 */
export function fireWindow(minutesUntil: number): ReminderWindow | null {
  if (minutesUntil <= 1 && minutesUntil > -1) return 'm1'; // small negative grace
  if (minutesUntil <= 10 && minutesUntil > 1) return 'm10';
  return null;
}
